module.exports = __webpack_public_path__ + "static/media/36-6.9860e288.mp3";